"use client";

import staticData from "@/public/data/flight/results.json";
import noResultsImage from "@/public/svg/No-Flights.svg";
import Flex from "@/shared/components/common/Flex";
import List from "@/shared/components/common/List";
import type { Flight } from "@/types/services/flight/apis/Availability";
import FlightCard from "./flightCard";
import NoResult from "@/containers/components/NoResult";
import { usePagination } from "@/shared/hooks/usePagination";
import { useRef } from "react";
import { useDeviceType } from "@/shared/context/DeviceContext";

interface FlightListProps {
  searchParams: SearchParams;
  flights: Flight[];
}

export default function FlightList({ searchParams, flights }: FlightListProps) {
  const deviceType = useDeviceType();

  const ref = useRef(null);

  const { title, subtitle } = staticData.noResults;

  const paginatedFlights = usePagination<Flight>(flights, ref, null, {
    pageLimit: deviceType === "mobile" ? 2 : 4,
    debounce: 500,
  });

  return (
    <Flex direction={"col"} className="space-y-4">
      {paginatedFlights.length === 0 && (
        <NoResult title={title} description={subtitle} image={noResultsImage} />
      )}

      <List
        items={paginatedFlights}
        renderItems={(flight) => (
          <FlightCard searchParams={searchParams} flight={flight} />
        )}
      />

      <div ref={ref} />
    </Flex>
  );
}
